var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealerManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.296875 4C0.296875 2.06701 1.86388 0.5 3.79688 0.5H17.7969C19.7299 0.5 21.2969 2.06701 21.2969 4V18C21.2969 19.9331 19.7299 21.5 17.7969 21.5H3.79688C1.86388 21.5 0.296875 19.9331 0.296875 18V4ZM13.1302 13.3333C13.1302 12.689 13.6525 12.1667 14.2969 12.1667H18.9635V4C18.9635 3.35567 18.4412 2.83333 17.7969 2.83333H3.79688C3.15255 2.83333 2.63021 3.35567 2.63021 4V12.1667H7.29688C7.9412 12.1667 8.46354 12.689 8.46354 13.3333C8.46354 14.622 9.50817 15.6667 10.7969 15.6667C12.0856 15.6667 13.1302 14.622 13.1302 13.3333Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerManagement);
export default __webpack_public_path__ + "static/media/dealer-management.53cca274c16f029d1aa1e351b03a7c5a.svg";
export { ForwardRef as ReactComponent };